const PLAYER_REPORTS = {
    'DEPOSIT_VIA_PSP': 'DEPOSIT_VIA_PSP', // 2
    'WIRE_TRANSFER_TRANSACTIONS': 'WIRE_TRANSFER_TRANSACTIONS', // 3
    'CREDIT_CARD_TRANSACTIONS' : 'CREDIT_CARD_TRANSACTIONS', // 4

    'WITHDRAWAL_VIA_PSP' : 'WITHDRAWAL_VIA_PSP',  // 5
    'PAYOUT_TRANSACTION' : 'PAYOUT_TRANSACTION' // 8
}

const FIUTemplatesTypes = {
    'BANK_ACCOUNT_TRANSFER' : 'BANK_ACCOUNT_TRANSFER', // 0
    'BANK_MERCHANT_TRANSFER': 'BANK_MERCHANT_TRANSFER', // 1
    ...PLAYER_REPORTS,
    'BANK_TO_BANK_INCOME_B2B': 'BANK_TO_BANK_INCOME_B2B', // 9
}

const BANK_TEMPLATES = [
    FIUTemplatesTypes.BANK_ACCOUNT_TRANSFER, 
    FIUTemplatesTypes.BANK_TO_BANK_INCOME_B2B
]

const PLAYER_TEMPLATES = Object.keys(PLAYER_REPORTS)
   


module.exports = {
    FIUTemplatesTypes,
    PLAYER_REPORTS,
    BANK_TEMPLATES,
    PLAYER_TEMPLATES
}